import React from 'react';
import { connect } from 'react-redux';
import { Text, Button, Theme, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { numberWithCommas } from "../../../services/helpers";
import store from "../../../redux/store";

/**
 *
 * @param {*} param0
 */
const ClaimSuccess = ({ uid, amountClaimed, patient, close }) => {
    const styles = {
        container: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            maxWidth: 500
        },
        main: {
            display: 'flex',
            flex: 1,
            overflow: 'auto',
            flexDirection: 'column',
            marginBottom: 20,
            justifyContent: 'center',
            alignItems: 'center',
            paddingLeft: 20,
            paddingRight: 20
        },
        btn: {
            backgroundColor: Theme.colors.surface,
            height: 60,
            borderRadius: 0
        }
    };

    return (
        <div style={ styles.container }>
            <div style={styles.main}>
                <Text
                    color={Theme.colors.surface}
                    display="block"
                    largest
                >
                    { i18n.t(tokens.labels.claims.claimCompleted) }
                </Text>

                <Text
                    color={Theme.colors.surface}
                    display="block"
                    medium
                >
                    { i18n.t(tokens.labels.claims.claimIdentifier, { uid }) }
                </Text>

                <Text
                    align="center"
                    color={Theme.colors.surface}
                    display="block"
                    margin="20px 0 0 0"
                    medium
                >
                    { i18n.t(tokens.labels.claims.claimDetails, { amountClaimed: numberWithCommas(amountClaimed), patient })}
                </Text>
            </div>

            <Button
                onClick={ close }
                customStyle={ styles.btn }
                fullWidth
                color="white"
            >
                <Text
                    medium
                    bold
                    color={store.getState().whitelabel.primaryColor || Theme.colors.skyBlue}>{ i18n.t(tokens.buttons.done) }</Text>
            </Button>
        </div>
    );
};

export default connect()(ClaimSuccess);